<template>
  <div class="modal">
    <form id="modal-form" @submit.prevent="addOrder" class="modal__form">
      <div class="modal__close">Закрыть</div>
      <h3 class="modal__form-title">Оставьте заявку</h3>
      <p class="modal__form-text">
        Для получения заявок, оставьте номер телефона и ваше имя. Наш менеджер
        расскажет вам все подробнее.
      </p>
      <div class="input-group modal__input-group">
        <input
          v-model="name"
          :class="{
            'is-invalid':
              ($v.name.$dirty && !$v.name.required) ||
              ($v.name.$dirty && !$v.name.minLength),
          }"
          id="modal-name"
          name="modalName"
          placeholder="Как вас зовут?"
          class="modal__input"
          type="text"
        />
        <label class="invalid" v-if="$v.name.$dirty && !$v.name.required"
          >Обязательное поле.</label
        >
        <label class="invalid" v-else-if="$v.name.$dirty && !$v.name.minLength"
          >Имя должно быть больше 3 букв</label
        >
      </div>
      <div class="input-group modal__input-group">
        <input
          v-model="phone"
          :class="{
            'is-invalid':
              ($v.phone.$dirty && !$v.phone.required) ||
              ($v.phone.$dirty && !$v.phone.isPhone),
          }"
          id="modal-phone"
          name="modalTel"
          placeholder="Введите номер телефона"
          class="modal__input"
          type="tel"
        />
        <label class="invalid" v-if="$v.phone.$dirty && !$v.phone.required"
          >Обязательное поле.</label
        >
        <label class="invalid" v-else-if="$v.phone.$dirty && !$v.phone.isPhone"
          >Неверный формат номера</label
        >
      </div>

      <button class="button modal__button">
        Записаться на консультацию
        <div v-show="isDisabled" class="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </button>
      <label class="policy">
          <input v-model="policy" class="policy__input" type="checkbox">
          <span class="policy__ok"></span>
          <span class="policy__text">Я согласен(на) с <a href="/politic" target="_blank">политикой конфиденциальности</a></span>
          <span class="invalid-feedback invalid-feedback--policy" v-if="!$v.policy.agree && $v.$dirty">Дайте согласие.</span>
      </label>
    </form>
  </div>
</template>

<script>
import Inputmask from "inputmask";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "Modal",
  data: () => ({
    name: "",
    phone: "",
    policy: true,
    polit: true,
    politDirty: false,
    checkbox: true,
    isDisabled: false,
    counters: null,
  }),
  methods: {
    clearData() {
      this.name = "";
      this.phone = "";
      this.checkbox = false;
      this.politDirty = false;
    },
    addOrder() {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }
      this.isDisabled = true;
      axios
        .post("/api/order", {
          name: this.name,
          phone: this.phone.replace(/\D/g, ""),
          checkbox: this.checkbox,
          host: window.location.host,
          referrer: document.referrer,
          url_query_string: sessionStorage.getItem('urlQueryString'),
        })
        .then((response) => {
          this.clearData();
          this.$v.$reset();
          this.isDisabled = false;
          if (response.status === 200) {
            $("#staticBackdrop").modal("hide");
            //console.log(response.data)
            if (this.counters.ym) ym(this.counters.ym, "reachGoal", "order");
            if (this.counters.fbq) fbq("track", "Contact");
            if (this.counters.mailTarget) {
              var _tmr = window._tmr || (window._tmr = []);
              _tmr.push({
                type: "reachGoal",
                id: ` "${this.counters.mailTarget.id}" `,
                goal: ` "${this.counters.mailTarget.goal}" `,
              });
            }
            document.querySelector(".modal").classList.remove("modal--visible");
            setTimeout(() => this.$store.dispatch("viewOrHideThanks"), 500);
          }
        })
        .catch((error) => {
          this.isDisabled = false;
          console.log(error.message);
        });
    },
  },
  validations: {
    name: { required, minLength: minLength(3) },
    phone: {
      required,
      isPhone: (phone) => {
        const phoneRe = /^(8|7)[\d]{10}$/;
        if (phone) {
          const digits = phone.replace(/\D/g, "");
          return phoneRe.test(digits);
        }
        return false;
      },
    },
    checkbox: { isCheck: (check) => check },
    policy: {
        agree: (value) => {
            return value
        }
    }
  },
  created() {
    axios
      .get("/api/counters")
      .then((response) => {
        this.counters = response.data;
      })
      .catch((error) => {
        console.log(error.message);
      });
  },
  mounted() {
    Inputmask({ mask: "+7 (999) - 999 - 99 - 99" }).mask("#modal-phone");

    const modal = document.querySelector(".modal"),
      close = document.querySelector(".modal__close"),
      triggers = document.querySelectorAll(".button__trigger");

    triggers.forEach((trigger) => {
      trigger.addEventListener("click", () => {
        modal.classList.toggle("modal--visible");
      });
    });
    close.addEventListener("click", () => {
      modal.classList.remove("modal--visible");
    });
    modal.addEventListener("click", (e) => {
      if (e.target.classList.contains("modal")) {
        modal.classList.remove("modal--visible");
      }
    });
  },
};
</script>

<style scoped>
.is-invalid {
  border: 1px solid tomato;
  color: tomato;
}

button[type="submit"]:disabled {
  color: #fff;
}
.alert {
  font-size: 1.6rem;
}
.invalid-feedback-head {
  position: relative;
}
.invalid-feedback {
  position: absolute;
  top: -1.5rem;
  left: 0;
  width: 100%;
  color: red;
}

.is-invalid-checkbox {
  color: red;
}

.invalid-feedback--policy {
    text-align: center;
    top: auto;
    bottom: -15px;
}

.policy {
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    /* width: 100%; */
    max-width: 410px;
    margin: 10px auto 15px;
    position: relative;
}

.policy__input {
    display: none;
}

.policy__ok {
    display: block;
    min-width: 20px;
    width: 20px;
    height: 20px;
    border-radius: 5px;
    position: relative;
    background-color: #fff;
    border: 1px solid #000;
}

.policy__ok:after {
    content: "";
    width: 30px;
    height: 15px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: url('../../img/ok.svg') no-repeat center/contain;
    display: none;
}


.policy__input:checked+.policy__ok:after {
    display: block;
}

.policy__text {
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-align: left;
}

.policy__text a {
    font-size: 14px;
    color: #111419;
    text-decoration: underline;
}
</style>
